import React, { Component } from "react";
import {Link} from "react-router-dom";

import emailjs from 'emailjs-com';

export default function AboutUs() {

  function sendEmail(e) {
    e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

    emailjs.sendForm('gmail', 'templateid', e.target, 'user_rFknE7VTzqaXHQwqh4Bx0')
      .then((result) => {
          window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
      }, (error) => {
          console.log(error.text);
      });
  };


    return (
        <>

            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Contact US</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Contact Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="contact-wrapper pt-40">
                <div className="contact-cards">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="contact-card">
                                    <div className="contact-icon"><i className="flaticon-arrival" />
                                    </div>
                                    <div className="contact-info">
                                        <p>Umm Al Thuoob</p>
                                        <p>New Industrial Area</p>
                                        <p>Umm Al Quwain</p>
                                        <p>United Arab Emirates.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="contact-card">
                                    <div className="contact-icon"><i className="flaticon-customer-service" />
                                    </div>
                                    <div className="contact-info">
                                        <h5>Mobile</h5>
                                        <p>+971 50 4717658</p>


                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="contact-card">
                                    <div className="contact-icon"><i className="flaticon-customer-service" />
                                    </div>
                                    <div className="contact-info">
                                        <h5>Email </h5>
                                            <p style={{marginLeft:-40}}>jagtechnicalservice@gmail.com</p>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">

                            </div>
                        </div>
                    </div>
                </div>


                <div className="container">
                    <div className="contact-inputs pt-40">
                        <div className="row">

                            <div className="col-lg-6">
                                <div className="contact-form">


                                    <form className="contact-form" onSubmit={sendEmail} >
                                        <h5 className="contact-d-head">Contact Form</h5>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <input type="text" name="user_name" placeholder="Your Name" required />
                                            </div>

                                            <div className="col-lg-6">
                                                <input type="email" name="user_email" placeholder="Your Email" required/>
                                            </div>

                                            <div className="col-lg-6">
                                                <input type="text" name="subject" placeholder="Subject" required/>
                                            </div>

                                            <div className="col-lg-12">
                                                <textarea cols={30} rows={7} name="message" placeholder="Write Your Queries" defaultValue={""} />
                                            </div>
                                            <div className="col-lg-12" >
                                                <input type="submit" value="Send" />
                                            </div>
                                        </div>
                                    </form>
                                </div><br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
